import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Countries } from '@app/constants/countries.constant';
import { RequestStatuses } from '../models/common';
import { OtherPayType } from '../models/utils';

@Injectable({
	providedIn: 'root',
})
export class UtilsService {
	endpointBase = '/api/utils';

	constructor(private readonly http: HttpClient) {}

	getACList(listName: string): Observable<any> {
		return this.http.get('/api/autocomplete-list/simple/' + listName);
	}

	getPRPayFrequencies(): Observable<any> {
		return this.http.get(`${this.endpointBase}/prPayFrequencies`);
	}

	getPRPayTypes(): Observable<any> {
		return this.http.get(`${this.endpointBase}/prPayTypes`);
	}

	getPRFLSATypes(): Observable<any> {
		return this.http.get(`${this.endpointBase}/prFLSATypes`);
	}

	getCustomQueryParameterTypes(): Observable<any> {
		return this.http.get(`${this.endpointBase}/custom-query-parameter-types`);
	}

	getEmployeeStatuses(): Observable<any> {
		return this.http.get(`${this.endpointBase}/employeeStatuses`);
	}

	getMaritalStatuses(): Observable<any> {
		return this.http.get(`${this.endpointBase}/employee-marital-statuses`);
	}

	getStates(country?: Countries): Observable<any> {
		let params = new HttpParams();
		if (country) {
			params = params.set('country', country);
		}
		return this.http.get(`${this.endpointBase}/states`, {
			params,
		});
	}

	getTerminationReasons(): Observable<any> {
		return this.http.get(`${this.endpointBase}/terminationReasons`);
	}

	getTimeZones(): Observable<any> {
		return this.http.get(`${this.endpointBase}/timeZones`);
	}

	getPRDeductionFrequencies(): Observable<any> {
		return this.http.get(`${this.endpointBase}/prDeductionFrequencies`);
	}

	getOrbitContractCodes(): Observable<any> {
		return this.http.get(`${this.endpointBase}/orbitContractCodes`);
	}

	getOrbitPlanCodes(): Observable<any> {
		return this.http.get(`${this.endpointBase}/orbitPlanCodes`);
	}

	getOrbitPrimaryJobClasses(): Observable<any> {
		return this.http.get(`${this.endpointBase}/orbitPrimaryJobClasses`);
	}

	getBeginningTeacherStatuses(): Observable<any> {
		return this.http.get(`${this.endpointBase}/beginning-teacher-statuses`);
	}

	getCourseTypes(): Observable<any> {
		return this.http.get(`${this.endpointBase}/course-types`);
	}

	getRaces(): Observable<any> {
		return this.http.get(`${this.endpointBase}/races`);
	}

	getJournalCodes(): Observable<any> {
		return this.http.get(`${this.endpointBase}/journalCodes`);
	}

	getMonthsToSelectOption(months: string[]) {
		return months.map((m) => {
			const obj = { value: 0, label: m };
			switch (m) {
				case 'January':
					obj.value = 1;
					break;
				case 'February':
					obj.value = 2;
					break;
				case 'March':
					obj.value = 3;
					break;
				case 'April':
					obj.value = 4;
					break;
				case 'May':
					obj.value = 5;
					break;
				case 'June':
					obj.value = 6;
					break;
				case 'July':
					obj.value = 7;
					break;
				case 'August':
					obj.value = 8;
					break;
				case 'September':
					obj.value = 9;
					break;
				case 'October':
					obj.value = 10;
					break;
				case 'November':
					obj.value = 11;
					break;
				case 'December':
					obj.value = 12;
					break;
			}
			return obj;
		});
	}

	getFiscalMonthsToSelectOption(months: string[]) {
		return months.map((m) => {
			const obj = { value: 0, label: m };
			switch (m) {
				case 'January':
					obj.value = 7;
					break;
				case 'February':
					obj.value = 8;
					break;
				case 'March':
					obj.value = 9;
					break;
				case 'April':
					obj.value = 10;
					break;
				case 'May':
					obj.value = 11;
					break;
				case 'June':
					obj.value = 12;
					break;
				case 'July':
					obj.value = 1;
					break;
				case 'August':
					obj.value = 2;
					break;
				case 'September':
					obj.value = 3;
					break;
				case 'October':
					obj.value = 4;
					break;
				case 'November':
					obj.value = 5;
					break;
				case 'December':
					obj.value = 6;
					break;
			}
			return obj;
		});
	}

	getMonthById(month: number) {
		const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
		return months[month - 1];
	}

	getFiscalMonthById(month: number) {
		const months = ['July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March', 'April', 'May', 'June'];
		return months[month - 1];
	}

	getRequestStatuses() {
		return this.http.get<RequestStatuses>(`${this.endpointBase}/requestStatuses`);
	}

	getOtherPayTypes() {
		return this.http.get<OtherPayType[]>(`${this.endpointBase}/otherPayTypes`);
	}

	getTinTypes(): Observable<any> {
		return this.http.get(`${this.endpointBase}/tinTypes`);
	}

	getVendor1099Boxes(): Observable<any> {
		return this.http.get(`${this.endpointBase}/vendor-1099-boxes`);
	}

	getBankStatuses(): Observable<any> {
		return this.http.get(`${this.endpointBase}/bankStatuses`);
	}

	getCheckMemoLocation(): Observable<any> {
		return this.http.get(`${this.endpointBase}/checkMemoLocation`);
	}
}
